import { vectorToArray as G, roundColumnSums as X, sumColumns as q, selectColumns as Q, getColumnValues as Z, generateColumnsIfMissing as ee, groupByAndSum as te } from "../utils/arrow/helpers.js";
import { createWeeklyPlanFromDaily as se, createMonthlyPlanFromDaily as ie } from "../utils/arrow/planAggregation.js";
import { CONST as v } from "../utils/constants.js";
import { withGC as f } from "../utils/pyodide/gc.js";
import "../utils/pyodide/pyodideContext.js";
import { seriesToArrow as re, dataFrameToArrow as ne } from "../utils/pyodide/toJs/arrow.js";
import { PyodideObjectAsyncConstructable as ae } from "../utils/pyodideObjectAsyncConstructable.js";
import { yieldToMainThread as d } from "../utils/yieldToMainThread.js";
import { M as oe, e as ce } from "../index-DyQVTxYk.js";
import { m as de, t as pe } from "../arrow-D3W5NBRc.js";
function h(r) {
  const e = Object.prototype.toString.call(r);
  return r instanceof Date || typeof r == "object" && e === "[object Date]" ? new r.constructor(+r) : typeof r == "number" || e === "[object Number]" || typeof r == "string" || e === "[object String]" ? new Date(r) : /* @__PURE__ */ new Date(NaN);
}
function k(r, e) {
  return r instanceof Date ? new r.constructor(e) : new Date(e);
}
function K(r, e) {
  const t = h(r);
  return isNaN(e) ? k(r, NaN) : (e && t.setDate(t.getDate() + e), t);
}
const le = 6048e5, ue = 864e5;
function me(r, e) {
  const t = e?.weekStartsOn, s = h(r), i = s.getDay(), n = (i < t ? 7 : 0) + i - t;
  return s.setDate(s.getDate() - n), s.setHours(0, 0, 0, 0), s;
}
function D(r) {
  return me(r, { weekStartsOn: 1 });
}
function ye(r) {
  const e = h(r), t = e.getFullYear(), s = k(r, 0);
  s.setFullYear(t + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const i = D(s), n = k(r, 0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  const a = D(n);
  return e.getTime() >= i.getTime() ? t + 1 : e.getTime() >= a.getTime() ? t : t - 1;
}
function N(r) {
  const e = h(r);
  return e.setHours(0, 0, 0, 0), e;
}
function J(r) {
  const e = h(r), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +r - +t;
}
function he(r, e) {
  const t = N(r), s = N(e), i = +t - J(t), n = +s - J(s);
  return Math.round((i - n) / ue);
}
function ge(r) {
  const e = ye(r), t = k(r, 0);
  return t.setFullYear(e, 0, 4), t.setHours(0, 0, 0, 0), D(t);
}
function _e(r, e) {
  const t = h(r), s = h(e), i = I(t, s), n = Math.abs(he(t, s));
  t.setDate(t.getDate() - i * n);
  const a = +(I(t, s) === -i), p = i * (n - a);
  return p === 0 ? 0 : p;
}
function I(r, e) {
  const t = r.getFullYear() - e.getFullYear() || r.getMonth() - e.getMonth() || r.getDate() - e.getDate() || r.getHours() - e.getHours() || r.getMinutes() - e.getMinutes() || r.getSeconds() - e.getSeconds() || r.getMilliseconds() - e.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function fe(r) {
  const e = h(r);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function F(r) {
  const e = h(r), t = +D(e) - +ge(e);
  return Math.round(t / le) + 1;
}
function B(r) {
  let t = h(r).getDay();
  return t === 0 && (t = 7), t;
}
function T(r, e) {
  const t = h(r), s = B(t), i = e - s;
  return K(t, i);
}
var we = /* @__PURE__ */ ((r) => (r.BUDGET = "budget", r.MEDIA_KPI = "mediaKpi", r.TOTAL_KPI = "totalKpi", r))(we || {});
class Ie extends ae {
  constructor(e, t, s) {
    const i = async (n) => await n.runPython(`
            async def load_optimiser(data_source_reader):
                try:
                  from core_optimizer import Optimiser, MegastarOutputReader, InitialData
                  raw_data = data_source_reader.read()
                  initial_optimiser_data = InitialData(*raw_data)
                  return Optimiser(initial_optimiser_data)
                except Exception as ex:
                  print('Failed to load optimiser', ex)
                  raise ex

            load_optimiser
        `)(t.pyObject);
    super(
      e,
      i,
      s.optimiserWheelPath,
      s.duckDbWheelUrl,
      s.jsonConfig,
      s.options,
      s.initPyodide
    ), this.dataSourceReaderService = t;
  }
  dataSourceReaderService;
  get pyOptimiser() {
    return this.pyObject;
  }
  get messageBroker() {
    return this.pyObject.message_broker;
  }
  get investmentStep() {
    return 100;
  }
  cache_megastarOutputReaderService;
  _pyBridgeCache = {};
  _toPyDate;
  lastNonMediaKpiUsed;
  get reader() {
    return this.cache_megastarOutputReaderService ??= new oe(
      void 0,
      this.pyObject.datasource_reader,
      {
        locales: [ce],
        pyodide: this.pyodide
      }
    );
  }
  get recentYearSpends() {
    return f(this.pyOptimiser).last_year_spends_detailed_pl.to_pandas().to_json();
  }
  get recentYearMediumTotalSpends() {
    const e = this.pyOptimiser.context.historic_spends.toJs();
    return JSON.stringify(e);
  }
  get naturalDemandIndiceDataFrames() {
    const e = async (t) => f(this.pyOptimiser.get_natural_demand(), async (s) => await re(this.pyodide, s.at(t)));
    return {
      get Monthly() {
        return e(0);
      },
      get WeeklyByWeekOfMonth() {
        throw new Error("Not implemented");
      },
      get Weekly() {
        return e(1);
      },
      get Daily() {
        return e(2);
      }
    };
  }
  getNaturalDemandData() {
    return this.pyOptimiser.get_natural_demand().toJs();
  }
  get allocation() {
    return this.optimalSpends;
  }
  get medias() {
    return this.pyObject.context.media.toJs();
  }
  getRoiCurvesData() {
    const t = this.getBridgeFn("generate_roi_curves")(this.pyOptimiser, "y");
    return JSON.parse(t);
  }
  get diminishing() {
    return f(this.pyObject).get_diminishing().toJs();
  }
  get optimalSpends() {
    const e = f(this.pyObject).optimal_spends.toJs();
    return JSON.stringify(e);
  }
  get lowestLimits() {
    return f(this.pyObject.get_context()).lower_limits.toJs();
  }
  get highestLimits() {
    return f(this.pyObject.get_context()).upper_limits.toJs();
  }
  get lowestBudget() {
    return f(this.pyObject.get_context()).lowest_budget;
  }
  get highestBudget() {
    return f(this.pyObject.get_context()).highest_budget;
  }
  get maxBudget() {
    return this.highestBudget;
  }
  _mostRecentYearRowCount = 0;
  diminishingPoint(e) {
    const t = G(e), s = t.map((i, n) => {
      const a = t[n - 1] || 0;
      return i - a;
    });
    return s.indexOf(Math.max(...s)) * this.investmentStep;
  }
  computePeriodOverrides(e, t = !0) {
    const s = Math.max(1, Math.floor(e)) / 366, i = this.pyOptimiser.get_context(), n = i.lower_limits.toJs(), a = i.upper_limits.toJs(), p = i.spend_periods.toJs(), l = n.map((c) => c * s), u = a.map((c) => c * s), m = p.map((c, g) => l[g] === 0 && u[g] === 0 ? 0 : Math.max(Math.min(t ? Math.round(c * s) : Math.floor(c), Math.floor(e)), 1));
    return { lower_limits: l, upper_limits: u, spend_periods: m };
  }
  getBridgeFn(e) {
    const t = e;
    return this._pyBridgeCache[t] || (this._pyBridgeCache[t] = this.pyodide.runPython(`
        from core_optimizer.optimiser.pyodide_bridge import ${e}
        ${e}
      `)), this._pyBridgeCache[t];
  }
  getToPyDate() {
    return this._toPyDate || (this._toPyDate = this.pyodide.runPython(`
        from datetime import datetime
        def to_py_datetime(js_date):
            return datetime.fromtimestamp(js_date.valueOf() / 1000)
        to_py_datetime
      `)), this._toPyDate;
  }
  getSpendLimitsFromContext() {
    const e = this.pyOptimiser.get_context(), t = e.lower_limits.toJs(), s = e.upper_limits.toJs(), i = e.media.toJs(), n = {}, a = {};
    return i.forEach((p, l) => {
      n[p] = t[l], a[p] = s[l];
    }), { medias: i, minimumSpends: n, maximumSpends: a };
  }
  buildOptimal(e, t, s, i, n, a, p, l, u) {
    const m = e.toJs ? e.toJs() : e, c = t.map((_) => m[_] || 0), g = c.reduce((_, P) => _ + P, 0), w = a + p;
    return {
      budget: u === "budget" ? l : g,
      currentKpi: u === "totalKpi" ? w : a,
      totalKpi: w,
      mediums: t,
      spends: c,
      minimumSpends: s,
      maximumSpends: i,
      kpis: n
    };
  }
  async resetOptimisationRules() {
    this.pyOptimiser.rules.reset_rules();
  }
  async readMessages() {
    const e = this.messageBroker.get_messages_and_clear().toJs();
    return e && e.length > 0 ? e.map((t) => ({
      messageLevel: t.message_level?.toString() || "ERROR",
      message: t.message?.toString() || "",
      timestamp: t.timestamp?.toString() || "",
      code: t.code?.toString() || ""
    })) : [];
  }
  async addOptimisationExactBudgetRule(e, t) {
    await d();
    const s = this.pyOptimiser.get_context();
    this.pyOptimiser.rules.process_rule_addition_request(
      s,
      e,
      "Total budget",
      "is exactly",
      t.toString()
    ), await d();
  }
  async getMediasLimits() {
    const { medias: e, minimumSpends: t, maximumSpends: s } = this.getSpendLimitsFromContext();
    return e.map((i) => ({
      medium: i,
      lowerLimit: t[i],
      upperLimit: s[i]
    }));
  }
  async getActiveDaysPerMedium() {
    await this.ensureInitialized(), await d();
    const e = this.dataSourceReaderService, [t] = e.getSpendPeriods();
    return t;
  }
  async updateRules(e) {
    await d();
    try {
      const t = e.map((i) => ({
        channel: i.channel,
        type: i.type,
        subtype: i.subtype,
        value: i.value
      })), s = this.pyodide.toPy(t);
      this.pyOptimiser.rules.update_rules(s), s.destroy();
    } catch (t) {
      throw new Error(`Failed to update rules: ${t.message}`);
    }
    await d();
  }
  async getKPILimits(e, t, s) {
    if (e && t && t > 0) {
      const { lower_limits: n, upper_limits: a, spend_periods: p } = this.computePeriodOverrides(t, s !== !1), u = this.getBridgeFn("get_kpi_bounds_with_context")(this.pyOptimiser, n, a, p).toJs();
      return [u[0], u[1]];
    }
    const i = this.pyOptimiser.get_kpi_bounds().toJs();
    return [i[0], i[1]];
  }
  async getBudgetLimits(e, t) {
    if (e && t && t > 0) {
      const i = Math.max(1, Math.floor(t)) / 366, n = this.pyOptimiser.get_context(), a = n.lower_limits.toJs(), p = n.upper_limits.toJs(), l = Math.round(a.reduce((m, c) => m + c * i, 0)), u = Math.round(p.reduce((m, c) => m + c * i, 0));
      return [l, u];
    }
    const s = this.pyOptimiser.get_budget_bounds().toJs();
    return [s[0], s[1]];
  }
  async getTotalKPILimits(e, t, s) {
    if (e && t && t > 0) {
      const n = K(e, t - 1);
      this.getBridgeFn("prepare_period")(this.pyOptimiser, this.toPyDate(e), this.toPyDate(n));
      const { lower_limits: p, upper_limits: l, spend_periods: u } = this.computePeriodOverrides(t, s !== !1), c = this.getBridgeFn("get_total_kpi_bounds_with_context")(this.pyOptimiser, p, l, u).toJs();
      return [c[0], c[1]];
    }
    const i = this.pyOptimiser.get_total_kpi_bounds().toJs();
    return [i[0], i[1]];
  }
  async getNonMediaKpi() {
    return this.lastNonMediaKpiUsed !== void 0 ? this.lastNonMediaKpiUsed : this.pyOptimiser._get_non_media_kpi_for_period();
  }
  async setAllowedWeekdays(e, t) {
    if (t.length !== 7)
      throw new Error("weekdayFlags must be an array of exactly 7 boolean values (Monday-Sunday)");
    await d();
    try {
      const i = this.pyOptimiser.daily_plan_manager.allowed_weekdays, n = this.pyodide.toPy(t);
      i.set(e, n), n.destroy(), this.pyOptimiser.latest_daily_plan = null;
    } catch (s) {
      throw new Error(`Failed to set allowed weekdays for ${e}: ${s.message}`);
    }
    await d();
  }
  async clearDailyPlanCache() {
    await d();
    try {
      this.pyOptimiser.latest_daily_plan = null;
      const e = this.pyOptimiser.daily_plan_manager.cache_manager;
      e && typeof e.clear == "function" && e.clear();
    } catch (e) {
      console.warn("Failed to clear daily plan cache:", e.message);
    }
    await d();
  }
  async getAllowedWeekdays(e) {
    try {
      const i = this.pyOptimiser.daily_plan_manager.allowed_weekdays.get(e);
      return i !== void 0 ? i.toJs ? i.toJs() : Array.from(i) : [!0, !0, !0, !0, !0, !0, !0];
    } catch (t) {
      throw new Error(`Failed to get allowed weekdays for ${e}: ${t.message}`);
    }
  }
  async getAllAllowedWeekdays() {
    try {
      const s = this.pyOptimiser.daily_plan_manager.allowed_weekdays.toJs(), i = {};
      for (const [n, a] of Object.entries(s))
        Array.isArray(a) ? i[n] = a : a && typeof a == "object" ? i[n] = Object.values(a) : i[n] = [!0, !0, !0, !0, !0, !0, !0];
      return i;
    } catch (e) {
      throw new Error(`Failed to get all allowed weekdays: ${e.message}`);
    }
  }
  async validateTarget(e, t) {
    let s, i;
    t === "totalKpi" ? [s, i] = await this.getTotalKPILimits() : t === "mediaKpi" ? [s, i] = await this.getKPILimits() : [s, i] = await this.getBudgetLimits();
    const n = t === "totalKpi" ? "Total KPI" : t === "mediaKpi" ? "Media KPI" : "Budget";
    return e < s ? {
      valid: !1,
      min: s,
      max: i,
      message: `Target ${n} (${e.toLocaleString()}) is below minimum achievable (${s.toLocaleString()}). The minimum spending constraints produce more ${n} than your target. Either increase your target or reduce the lower spending limits.`
    } : e > i ? {
      valid: !1,
      min: s,
      max: i,
      message: `Target ${n} (${e.toLocaleString()}) exceeds maximum achievable (${i.toLocaleString()}). Either decrease your target or increase the upper spending limits.`
    } : { valid: !0, min: s, max: i };
  }
  async optimise(e, t = "budget") {
    this.lastNonMediaKpiUsed = void 0;
    let s;
    if (t === "totalKpi")
      s = this.pyOptimiser.optimise_total_kpi(e);
    else {
      const c = t === "mediaKpi";
      s = this.pyOptimiser.optimise(e, c);
    }
    await d();
    const { medias: i, minimumSpends: n, maximumSpends: a } = this.getSpendLimitsFromContext();
    await d();
    const p = s.toJs(), l = i.map((c) => {
      try {
        return this.pyOptimiser.channel_kpi(p[c] || 0, c);
      } catch {
        return 0;
      }
    });
    await d();
    const u = this.pyOptimiser.total_kpi(s), m = await this.getNonMediaKpi();
    return this.buildOptimal(
      s,
      i,
      n,
      a,
      l,
      u,
      m,
      e,
      t
    );
  }
  refineSpend(e) {
    return Math.round(e);
  }
  async createOptimisedPlans(e, t, s, i = "budget", n) {
    if (this.lastNonMediaKpiUsed = void 0, !t) {
      const y = JSON.parse(this.recentYearSpends)["Period name"], S = Math.min(...Object.keys(y).map(Number)), M = Math.max(...Object.keys(y).map(Number));
      t = new Date(y[S] * 1e3), s = new Date(y[M] * 1e3);
    }
    if (t > s)
      throw new Error("Start date for optimized plan does not situate before the end date");
    await d();
    const a = _e(s, t);
    if (a > v.MAX_DAYS_IN_YEAR)
      throw new Error(`Period (${a} days) is too long ( >${v.MAX_DAYS_IN_YEAR} ).`);
    await d();
    const p = n !== !1, l = a + 1, u = this.toPyDate(t), m = this.toPyDate(s);
    this.getBridgeFn("prepare_period")(this.pyOptimiser, u, m), await d();
    const { lower_limits: g, upper_limits: w, spend_periods: b } = this.computePeriodOverrides(l, p);
    let _ = e;
    const P = i === "mediaKpi" || i === "totalKpi";
    if (i === "totalKpi") {
      const o = this.pyOptimiser._get_non_media_kpi_for_period();
      _ -= o, this.lastNonMediaKpiUsed = o;
    }
    if (P) {
      const y = this.getBridgeFn("get_kpi_bounds_with_context")(this.pyOptimiser, g, w, b).toJs();
      _ = Math.max(y[0], Math.min(_, y[1]));
    } else {
      const o = Math.round(g.reduce((S, M) => S + M, 0)), y = Math.round(w.reduce((S, M) => S + M, 0));
      _ = Math.max(o, Math.min(_, y));
    }
    this.getBridgeFn("optimize_with_context")(
      this.pyOptimiser,
      _,
      P,
      g,
      w,
      b
    ), await d();
    let O = await f(
      this.pyOptimiser.adjust_daily_plan(),
      async (o) => ne(this.pyodide, o)
    );
    const x = this.pyOptimiser.optimal_spends, { medias: Y, minimumSpends: j, maximumSpends: L } = this.getSpendLimitsFromContext(), W = this.getBridgeFn("recalculate_kpis_with_context")(
      this.pyOptimiser,
      x,
      g,
      w,
      b
    ).toJs();
    await d();
    const A = this.getBridgeFn("total_kpi_with_context")(
      this.pyOptimiser,
      x,
      g,
      w,
      b
    ), C = await this.getNonMediaKpi(), E = this.buildOptimal(
      x,
      Y,
      j,
      L,
      W,
      A,
      C,
      e,
      i
    );
    await d();
    const R = X(q(Q(O, this.medias), this.medias)), $ = de(new Float64Array(this.medias.map((o) => R[o] || 0))), H = Z(O, "Period name").map(
      (o) => new Date(Number(typeof o == "bigint" ? o / 1000n : o))
    );
    O = ee(O, H, [
      ["Year", (o) => o.getFullYear()],
      ["Month", (o) => o.getMonth() + 1],
      ["ISO Month", (o) => T(o, 4).getMonth() + 1],
      ["ISO Week of Year", F],
      [
        "ISO Week of Month",
        (o) => {
          const y = F(K(fe(T(o, 4)), 3));
          return F(o) - y + 1;
        }
      ],
      ["ISO Weekday", B]
    ]), await d();
    const U = se(O, this.medias), V = ie(O, this.medias), z = this.calculatePlanFor("ISO Weekday", O);
    return await d(), {
      optimal: E,
      refinedSpends: $,
      optimizedPlan: O,
      monthly: V,
      weekly: U,
      daily: z
    };
  }
  calculatePlanFor(e, t) {
    const s = te(t, e, this.medias), i = {};
    return i[e] = s.map((n) => n[e]), this.medias.forEach((n) => {
      i[n] = s.map((a) => a[n] || 0);
    }), pe(i);
  }
  toPyDate(e) {
    return this.getToPyDate()(e);
  }
  /**
   * Returns the version of the optimizer Python package (core_optimizer).
   */
  getOptimizerVersion() {
    return this.pyodide.runPython(`
      from importlib.metadata import version
      def get_version():
        return version('core_optimizer')
      get_version
    `)();
  }
  replayFromJsonl(e) {
    return this.pyOptimiser.replay_from_jsonl(e);
  }
  async close() {
    super.close(), await this.dataSourceReaderService.close();
  }
}
export {
  we as OptimizationMode,
  Ie as OptimizerService
};
